import { useField } from 'formik';
import { Grid } from '@frontierag/frontier-ui-library';
import Customers from './Customers';
import MultiAccount from './MultiAccount';
import { AccountRepresentativesField } from 'fields';
import OfficeLocation from './OfficeLocation';
import Notes from './Notes';
import TransportMethod from './TransportMethod';
import DeliveryDate from './DeliveryDate';
import DeliveryAddress from './DeliveryAddress';
import { APP_PRODUCT_TYPE } from 'appConstants';

export default function CustomerDetails() {
  const [{ value: customerReference }] = useField('customer.customerReference');

  return (
    <Grid direction="column" container rowSpacing={3} wrap="nowrap">
      <Grid item>
        <Customers name="customer" />
      </Grid>
      {customerReference && (
        <Grid item sx={{ ':empty': { display: 'none' } }}>
          <MultiAccount customerReference={customerReference} />
        </Grid>
      )}
      <Grid item>
        <AccountRepresentativesField
          name="representative"
          textFieldProps={{ required: true }}
          productType={APP_PRODUCT_TYPE.CROP}
        />
      </Grid>
      <Grid item>
        <OfficeLocation />
      </Grid>
      <Grid item>
        <TransportMethod />
      </Grid>
      <Grid item>
        <DeliveryDate />
      </Grid>
      <Grid item>
        <DeliveryAddress customerReference={customerReference} />
      </Grid>
      <Grid item>
        <Notes />
      </Grid>
    </Grid>
  );
}
